import type { TaskTemplate } from "@/domains/tasks/api/types";

export const SEED_TASK_TEMPLATES: ReadonlyArray<TaskTemplate> = [
  {
    id: "tpl-placement",
    name: "Plaatsing nieuwe camera",
    description:
      "Volledige checklist voor een eerste plaatsing — administratieve voorbereiding, technische configuratie en plaatsing op locatie.",
    items: [
      {
        title: "Teams: mapje aanmaken voor dit dossier",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -3,
      },
      {
        title: "Teams: aanvraag en foto's van plaatsbezoek opslaan",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -3,
      },
      {
        title: "Breng 802 in kennis via mail",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Teamwork: velden in tabelweergave aanvullen",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Excel 'camerabeheer' aanvullen",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Doofplan: nakijken of activeren",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: -1,
      },
      {
        title: "Genetec configtool: functionele naam instellen",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: -1,
      },
      {
        title: "Plaatsingsfirma briefen — plaatsdatum bevestigen",
        category: "external",
        assigneeKind: "partner",
        offsetDays: -1,
      },
      {
        title: "Camera plaatsen op locatie",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Kijkrichting nakijken en uitlijnen",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Foto's na plaatsing toevoegen aan dossier",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Eerste beeldcontrole — kwaliteit verifiëren",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 1,
      },
    ],
  },
  {
    id: "tpl-relocation",
    name: "Verplaatsing bestaande camera",
    description:
      "Camera verhuist van een oude naar een nieuwe locatie — administratieve aanpassingen, ophaling oude locatie en plaatsing nieuwe locatie.",
    items: [
      {
        title: "Teams: mapje van vorige locatie naar archief verplaatsen",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -3,
      },
      {
        title: "Teams: mapje aanmaken voor nieuwe locatie",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -3,
      },
      {
        title: "Teamwork: locatiegegevens updaten",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Excel 'camerabeheer' aanvullen met nieuwe locatie",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Plaatsingsfirma briefen — verplaatsingsdatum bevestigen",
        category: "external",
        assigneeKind: "partner",
        offsetDays: -1,
      },
      {
        title: "Camera ophalen op oude locatie",
        category: "decommission",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Camera plaatsen op nieuwe locatie",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Kijkrichting nakijken op nieuwe locatie",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Foto's na verplaatsing toevoegen aan dossier",
        category: "placement",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Genetec: functionele naam aanpassen",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 1,
      },
      {
        title: "Eerste beeldcontrole — kwaliteit verifiëren",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 1,
      },
    ],
  },
  {
    id: "tpl-pickup",
    name: "Ophaling camera",
    description:
      "Einde inzet — camera ophalen op locatie, dossier afsluiten en alle registers bijwerken.",
    items: [
      {
        title: "Plaatsingsfirma briefen — ophaaldatum bevestigen",
        category: "external",
        assigneeKind: "partner",
        offsetDays: -1,
      },
      {
        title: "Camera ophalen na einde inzet",
        category: "decommission",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Genetec: functionele naam terug naar default",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 1,
      },
      {
        title: "Teams: mapje verplaatsen naar archief",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: 1,
      },
      {
        title: "Excel 'camerabeheer' bijwerken — einde inzet",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: 1,
      },
      {
        title: "Dossier afsluiten en archiveren",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: 1,
      },
    ],
  },
  {
    id: "tpl-maintenance",
    name: "Onderhoud asset",
    description:
      "Onderhoudsflow voor een asset dat (preventief of na defect) uit dienst wordt genomen — inspectie, herstelling en terug operationeel maken.",
    items: [
      {
        title: "Defect of onderhoudsbehoefte documenteren",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: -2,
      },
      {
        title: "Genetec: status op 'buiten dienst' zetten",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: -1,
      },
      {
        title: "Plaatsingsfirma briefen — ophaaldatum voor onderhoud",
        category: "external",
        assigneeKind: "partner",
        offsetDays: -1,
      },
      {
        title: "Asset ophalen voor inspectie",
        category: "decommission",
        assigneeKind: "partner",
        offsetDays: 0,
      },
      {
        title: "Inspectie & diagnose uitvoeren",
        category: "operations",
        assigneeKind: "partner",
        offsetDays: 1,
      },
      {
        title: "Herstelling of preventief onderhoud uitvoeren",
        category: "operations",
        assigneeKind: "partner",
        offsetDays: 2,
      },
      {
        title: "Eindcontrole en functietest",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 3,
      },
      {
        title: "Excel 'camerabeheer' bijwerken — onderhoud geregistreerd",
        category: "administration",
        assigneeKind: "internal",
        offsetDays: 3,
      },
      {
        title: "Asset terug operationeel zetten in Genetec",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 3,
      },
    ],
  },
  {
    id: "tpl-custom",
    name: "Vrije taak",
    description:
      "Eén losse taak volgens het standaard takenpatroon — kies categorie, verantwoordelijke en deadline bij het toepassen.",
    items: [
      {
        title: "Nieuwe taak — beschrijving aanvullen",
        category: "operations",
        assigneeKind: "internal",
        offsetDays: 0,
      },
    ],
  },
];
